import { Component, ViewChildren, QueryList, NgZone, OnInit } from '@angular/core';
import {
  MenuController,
  Platform,
  IonRouterOutlet,
  ToastController,
  NavController
} from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Router } from '@angular/router';
import { NotificationsService } from './notifications.service';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { copyToClipboard } from './helpers/helpers';
import { ConstantsService } from './constants.service';
import { AuthService } from './auth/auth.service';
import { environment } from 'src/environments/environment';
import { App } from '@capacitor/app';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { register } from 'swiper/element/bundle';
import { TranslocoService } from '@ngneat/transloco';
import { PROMOTION_TYPES } from "./constants/promotions.constants";

import { Subscription } from 'rxjs';
import { LanguageService } from './language.service';
import { ProfileService } from './profile/profile.service';
import { TranslatorService } from './translator.service';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  lastTimeBackPress = 0;
  timePeriodToExit = 2000;
  userLoggedIn = false;
  versionNumber = `v1.0.1`;
  showLoyaltyCards = false;

  options: any[] = [];
  selectedOption: any = null;
  dropdownOpen = false;
  selectedId: string | null = null;
  private profileSub: Subscription;
  private idiomaSub: Subscription;

  @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private menuCtrl: MenuController,
    private router: Router,
    private toastCtrl: ToastController,
    private notificationsService: NotificationsService,
    private navCtrl: NavController,
    private socialSharing: SocialSharing,
    private constantsService: ConstantsService,
    private authService: AuthService,
    private zone: NgZone,
    private iab: InAppBrowser,
    private appVersion: AppVersion,
    private translocoService: TranslocoService,
    private languageService: LanguageService,
    private profileService: ProfileService,
    private translatorService: TranslatorService,
  ) {
    this.initializeApp();
    this.backButtonEvent();
  }

profileData = {
  name: '',
  lastName: '',
  username: '',
  languageId: null 
};

ionViewWillEnter() {
  this.removeSafeAreaClasses();
}

removeSafeAreaClasses() {
  const grids = document.querySelectorAll('ion-grid');
  grids.forEach((grid) => {
    grid.classList.remove('safearea');
    (grid as HTMLElement).style.paddingTop = '';
  });

  const contents = document.querySelectorAll('ion-content');
  contents.forEach((c) => {
    (c as HTMLElement).style.paddingTop = '';
  });
}

ngOnInit() {
  this.languageService.getOpciones().subscribe((response: any) => {
    const langs = response?.result?.items || [];
    this.options = langs
      .filter((lang: any) => lang.application === "client")
      .map((lang: any) => ({
        id: lang.id,
        text: lang.code.toLowerCase(),
        img: lang.image?.url || ''
      }));

    this.profileSub = this.profileService.getProfile().subscribe((profile:any) => {
      
      if(!profile)
      {
        profile = this.profileService.loadProfile();
      }
      if (profile) {
        this.profileData = {
          name: profile.name,
          lastName: profile.lastName,
          username: profile.user.username,
          languageId: profile.languageId || null 
        };

        const profileLang = this.options.find(opt => opt.id === this.profileData.languageId);
        this.selectedOption = profileLang || this.options[0];
        this.translatorService.changeLanguage(this.selectedOption, this.profileData);
      }
    });
    });

  this.idiomaSub = this.translatorService.onIdiomaCambiado().subscribe(() => {
    this.changeLanguage();
    });
}

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.notificationsService.init();
      this.loadConstants();

      this.authService.user.subscribe(res => {
        if (res) {
          this.userLoggedIn = true;
        } else {
          this.userLoggedIn = false;
        }
      });

      if (this.platform.is('cordova') || this.platform.is('capacitor')) {
        App.addListener('appUrlOpen', (data: any) => {
          this.zone.run(() => {
            try {
              const url = new URL(data.url);
              const { pathname, hash } = url;

              this.navCtrl.navigateRoot(pathname + hash);
            } catch (err) {
              console.log('Could not parse URL', err);
            }
          });
        });
        this.appVersion
          .getVersionNumber()
          .then(value => {
            this.versionNumber = `v${value}`;
          })
          .catch(err => {
            console.log('Could not get Version', err);
          });
      }
    });
  }

  toggleMenu() {
    this.menuCtrl.toggle();
  }

  handleFAQ() {
    this.iab.create(this.translocoService.translate('common.faqURL'), '_blank');
  }

  async handleShare() {
    if (this.platform.is('cordova') || this.platform.is('capacitor')) {
      this.socialSharing.share(
        this.translocoService.translate('onboarding.sharedMessage'),
        null,
        null,
        environment.webUrl
      );
    } else {
      copyToClipboard(environment.webUrl);
      const toast = await this.toastCtrl.create({
        message: this.translocoService.translate('common.copyLink'),
        duration: 2000,
        buttons: [
          {
            text: this.translocoService.translate('common.close'),
            role: 'cancel',
          }
        ],
      });
      toast.present();
    }
  }

  backButtonEvent() {
    if (
      this.platform.is('android') &&
      (this.platform.is('cordova') || this.platform.is('capacitor'))
    ) {
      this.platform.backButton.subscribe(async () => {
        this.routerOutlets.forEach((outlet: IonRouterOutlet) => {
          if (outlet && outlet.canGoBack()) {
            outlet.pop();
          } else if (
            this.router.url === '/catalogs' ||
            this.router.url === '/auth'
          ) {
            if (
              new Date().getTime() - this.lastTimeBackPress <
              this.timePeriodToExit
            ) {
              navigator['app'].exitApp(); // work for ionic 4
            } else {
              this.toastCtrl
                .create({
                  message: this.translocoService.translate('common.exit'),
                  duration: 1000
                })
                .then(toast => toast.present());
              this.lastTimeBackPress = new Date().getTime();
            }
          }
        });
      });
    }
  }

  loadConstants() {
    this.constantsService.fetchConstants().subscribe(({result: {constants}}) => {
      if (constants && constants.promotionTypeEnabled) {
        this.showLoyaltyCards = [PROMOTION_TYPES.LOYALTY,PROMOTION_TYPES.LOYALTY_DRINK].some(value => constants.promotionTypeEnabled.includes(value));
      }
    });
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectOption(option: any) {
  
    this.selectedOption = option;
    this.selectedId = option.id; 
    this.dropdownOpen = false;
    // Actualizo el idioma del usuario.
    this.translatorService.changeLanguage(option, this.profileData);

  }

 reloadIfSame(url: string) {
  if (this.router.url === url) {
      sessionStorage.setItem('Applanguage', this.translatorService.currentLang);
      window.location.reload();
  } else {
    this.router.navigate([url]);
  }
}



  changeLanguage()
  {
    this.selectedOption = this.options.find(option => option.text === this.translatorService.currentLang);
  }
}
